{
  "collapse": "طي",
  "expand": "تمديد"
}
